import {
    Modal,
    Avatar,
    Space,
    Button,
    Typography,
} from 'antd';
import { useNavigate } from 'react-router-dom';
import {
    AiFillCheckCircle,
    AiFillWarning,
    AiFillCloseCircle,
} from 'react-icons/ai';
import { FC } from 'react';

interface StatusProps {
    onClose: any;
    visible: boolean;
    type: string;
    topic: string;
    message: string;
    path: string;
    action: string;
}

const { Text } = Typography;

const Status: FC<StatusProps> = ({
    onClose, visible, type, topic, message, path, action, ...props
}: StatusProps) => {
    const navigate = useNavigate();

    const ICON_TYPE: any = {
        SUCCESS: <AiFillCheckCircle size={50} color="#6C8EEF" />,
        WARNING: <AiFillWarning size={50} color="#FFD700" />,
        ERROR: <AiFillCloseCircle size={50} color="#FF0000" />,
    };

    const modalProps = {
        centered: true,
        closable: false,
        visible,
        footer: null,
    };

    return (
        <Modal
            {...modalProps}
            {...props}
        >
            <Space direction="vertical" size={24} style={{ width: '100%' }} align="center">
                <Avatar
                    icon={ICON_TYPE[type]}
                    size={60}
                    style={{
                        background: '#D1DDFF',
                        margin: '0 auto',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                />
                <Space direction="vertical" size={8} align="center">
                    <span className="title--header-2 cl--secondary-purple center">
                        {topic}
                    </span>
                    <Text style={{ textAlign: 'center' }}>
                        {message}
                    </Text>
                </Space>
                <Button
                    type="primary"
                    block
                    onClick={() => navigate(path)}
                >
                    {action}
                </Button>
            </Space>
        </Modal>
    );
};

export default Status;
